import { FC } from "react";
import { PlayersList } from "./PlayersList"
import { SectionTitle } from "./SectionTitle"
import { PlayerInfo } from "../../types/fixtures/match";

interface LineupsProps {
    homePlayers: PlayerInfo[];
    awayPlayers: PlayerInfo[];
}

export const Lineups: FC<LineupsProps> = ({
    homePlayers,
    awayPlayers
}) => {
    return (
        <div>
            <SectionTitle>
                Составы команд
            </SectionTitle>
            <div className="flex flex-row justify-center gap-4">
                <PlayersList players={homePlayers} align="right"/>
                <PlayersList players={awayPlayers}/>
            </div>
        </div>
    )
}
